import axiosClient from './axiosClient';
import { ClientQuestionModel } from '../Models/clientQuestionModel';

const clientQuestionService = {
  getAll: () => {
    return axiosClient.get('/ClientQuestion')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /ClientQuestion returned 404. Falling back to GET /ClientQuestions...");
          return axiosClient.get('/ClientQuestions');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ClientQuestionModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (questionID) => {
    return axiosClient.get(`/ClientQuestion/${questionID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /ClientQuestion/${questionID} returned 404. Falling back to GET /ClientQuestions/${questionID}...`);
          return axiosClient.get(`/ClientQuestions/${questionID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientQuestionModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = ClientQuestionModel.toBackend(payload);
    body.questionId = 0;

    return axiosClient.post('/ClientQuestion', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /ClientQuestion returned 404. Falling back to POST /ClientQuestions...");
          return axiosClient.post('/ClientQuestions', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientQuestionModel.toFrontend(raw),
        };
      });
  },

  update: (questionID, payload) => {
    const body = ClientQuestionModel.toBackend({ ...payload, questionID });

    return axiosClient.put('/ClientQuestion', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /ClientQuestion returned 404. Falling back to PUT /ClientQuestions...");
          return axiosClient.put('/ClientQuestions', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientQuestionModel.toFrontend(raw),
        };
      });
  },

  remove: (questionID) => {
    return axiosClient.delete(`/ClientQuestion/${questionID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /ClientQuestion/${questionID} returned 404. Falling back to DELETE /ClientQuestions/${questionID}...`);
          return axiosClient.delete(`/ClientQuestions/${questionID}`);
        }
        return Promise.reject(err);
      });
  },

  getByProjectId: (projectID) => {
    return axiosClient.get(`/ClientQuestion/GetByProjectId/${projectID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET by project ID returned 404. Falling back to query filter...`);
          return axiosClient.get('/ClientQuestion');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ClientQuestionModel.toFrontend);
        const filteredList = res.config?.url?.includes('GetByProjectId') 
          ? mappedList 
          : mappedList.filter(q => Number(q.projectID) === Number(projectID));
        return {
          data: filteredList,
        };
      });
  }
};

export default clientQuestionService;
